var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
var SvgMessageUnreadDefault = function SvgMessageUnreadDefault(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    viewBox: "0 0 20 20",
    "aria-hidden": true,
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.01 5.01C3.576 5.01.018 7.944.018 11.502c0 1.499.593 2.872 1.623 3.965-.437 1.217-1.405 2.278-1.436 2.278-.219.219-.25.53-.156.812.125.28.406.437.718.437 1.904 0 3.433-.78 4.338-1.436a9.741 9.741 0 0 0 2.903.437c4.401 0 7.991-2.903 7.991-6.493 0-3.558-3.59-6.492-7.99-6.492Zm0 11.487a8.14 8.14 0 0 1-2.467-.375l-.718-.218-.593.437a6.966 6.966 0 0 1-1.81.905 5.84 5.84 0 0 0 .624-1.249l.344-.874-.656-.686c-.562-.593-1.217-1.592-1.217-2.934 0-2.747 2.903-4.995 6.492-4.995 3.559 0 6.493 2.248 6.493 4.994 0 2.778-2.934 4.995-6.493 4.995Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 5,
    r: 4.5,
    fill: "#CD000A",
    stroke: "#fff"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMessageUnreadDefault);
var Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;